import api from "@/lib/api";

export async function monitoringCards(unidade, setor) {
  const { data } = await api.get("/secretaria-digital/monitoring/cards", { params: { unidade, setor } })
  return data
}